module.exports = __webpack_public_path__ + "static/media/LogoDE.cdff38ba.svg";